var cov_y61i3kwkv = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/menu/menuCtrl.js',
      hash = '89d7e66d6826e894bf3f7a4ede480f5d53fdc760',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/menu/menuCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 201,
          column: 3
        }
      },
      '1': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 103
        }
      },
      '2': {
        start: {
          line: 5,
          column: 19
        },
        end: {
          line: 5,
          column: 82
        }
      },
      '3': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 104,
          column: 4
        }
      },
      '4': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 106
        }
      },
      '5': {
        start: {
          line: 9,
          column: 92
        },
        end: {
          line: 9,
          column: 101
        }
      },
      '6': {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 112
        }
      },
      '7': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      '8': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 28
        }
      },
      '9': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 39
        }
      },
      '10': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 24
        }
      },
      '11': {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 26
        }
      },
      '12': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 27
        }
      },
      '13': {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 49,
          column: 53
        }
      },
      '14': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 52,
          column: 7
        }
      },
      '15': {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 45
        }
      },
      '16': {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 24
        }
      },
      '17': {
        start: {
          line: 55,
          column: 23
        },
        end: {
          line: 55,
          column: 83
        }
      },
      '18': {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 60,
          column: 7
        }
      },
      '19': {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 43
        }
      },
      '20': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 15
        }
      },
      '21': {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 65,
          column: 7
        }
      },
      '22': {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 34
        }
      },
      '23': {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 15
        }
      },
      '24': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 30
        }
      },
      '25': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 84,
          column: 7
        }
      },
      '26': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 28
        }
      },
      '27': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 15
        }
      },
      '28': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 89,
          column: 7
        }
      },
      '29': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 28
        }
      },
      '30': {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 15
        }
      },
      '31': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      '32': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 29
        }
      },
      '33': {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 25
        }
      },
      '34': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 58
        }
      },
      '35': {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 27
        }
      },
      '36': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 101,
          column: 7
        }
      },
      '37': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 29
        }
      },
      '38': {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 108,
          column: 5
        }
      },
      '39': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 44
        }
      },
      '40': {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 112,
          column: 5
        }
      },
      '41': {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 52
        }
      },
      '42': {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 16
        }
      },
      '43': {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 190,
          column: 4
        }
      },
      '44': {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 109
        }
      },
      '45': {
        start: {
          line: 116,
          column: 95
        },
        end: {
          line: 116,
          column: 104
        }
      },
      '46': {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 132,
          column: 9
        }
      },
      '47': {
        start: {
          line: 131,
          column: 10
        },
        end: {
          line: 131,
          column: 22
        }
      },
      '48': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 114
        }
      },
      '49': {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 141,
          column: 7
        }
      },
      '50': {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 28
        }
      },
      '51': {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 39
        }
      },
      '52': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 24
        }
      },
      '53': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 26
        }
      },
      '54': {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 58
        }
      },
      '55': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 27
        }
      },
      '56': {
        start: {
          line: 149,
          column: 20
        },
        end: {
          line: 149,
          column: 53
        }
      },
      '57': {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 152,
          column: 7
        }
      },
      '58': {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 151,
          column: 45
        }
      },
      '59': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 24
        }
      },
      '60': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 157,
          column: 7
        }
      },
      '61': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 50
        }
      },
      '62': {
        start: {
          line: 156,
          column: 8
        },
        end: {
          line: 156,
          column: 15
        }
      },
      '63': {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 162,
          column: 7
        }
      },
      '64': {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 160,
          column: 54
        }
      },
      '65': {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 161,
          column: 15
        }
      },
      '66': {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 164,
          column: 52
        }
      },
      '67': {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 171,
          column: 7
        }
      },
      '68': {
        start: {
          line: 169,
          column: 8
        },
        end: {
          line: 169,
          column: 28
        }
      },
      '69': {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 15
        }
      },
      '70': {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 176,
          column: 7
        }
      },
      '71': {
        start: {
          line: 174,
          column: 8
        },
        end: {
          line: 174,
          column: 28
        }
      },
      '72': {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 15
        }
      },
      '73': {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 180,
          column: 7
        }
      },
      '74': {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 29
        }
      },
      '75': {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 25
        }
      },
      '76': {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 58
        }
      },
      '77': {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 27
        }
      },
      '78': {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 188,
          column: 7
        }
      },
      '79': {
        start: {
          line: 187,
          column: 8
        },
        end: {
          line: 187,
          column: 29
        }
      },
      '80': {
        start: {
          line: 192,
          column: 29
        },
        end: {
          line: 192,
          column: 95
        }
      },
      '81': {
        start: {
          line: 193,
          column: 2
        },
        end: {
          line: 195,
          column: 5
        }
      },
      '82': {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 194,
          column: 54
        }
      },
      '83': {
        start: {
          line: 197,
          column: 2
        },
        end: {
          line: 200,
          column: 5
        }
      },
      '84': {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 62
        }
      },
      '85': {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 199,
          column: 16
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 45
          },
          end: {
            line: 2,
            column: 46
          }
        },
        loc: {
          start: {
            line: 2,
            column: 77
          },
          end: {
            line: 201,
            column: 1
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 83
          },
          end: {
            line: 9,
            column: 84
          }
        },
        loc: {
          start: {
            line: 9,
            column: 92
          },
          end: {
            line: 9,
            column: 101
          }
        },
        line: 9
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 34,
            column: 13
          },
          end: {
            line: 34,
            column: 14
          }
        },
        loc: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 34
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 106,
            column: 64
          },
          end: {
            line: 106,
            column: 65
          }
        },
        loc: {
          start: {
            line: 106,
            column: 72
          },
          end: {
            line: 108,
            column: 3
          }
        },
        line: 106
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 109,
            column: 28
          },
          end: {
            line: 109,
            column: 29
          }
        },
        loc: {
          start: {
            line: 109,
            column: 36
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 109
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 116,
            column: 86
          },
          end: {
            line: 116,
            column: 87
          }
        },
        loc: {
          start: {
            line: 116,
            column: 95
          },
          end: {
            line: 116,
            column: 104
          }
        },
        line: 116
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 129,
            column: 16
          },
          end: {
            line: 129,
            column: 17
          }
        },
        loc: {
          start: {
            line: 129,
            column: 24
          },
          end: {
            line: 134,
            column: 7
          }
        },
        line: 129
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 193,
            column: 84
          },
          end: {
            line: 193,
            column: 85
          }
        },
        loc: {
          start: {
            line: 193,
            column: 92
          },
          end: {
            line: 195,
            column: 3
          }
        },
        line: 193
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 197,
            column: 38
          },
          end: {
            line: 197,
            column: 39
          }
        },
        loc: {
          start: {
            line: 197,
            column: 46
          },
          end: {
            line: 200,
            column: 3
          }
        },
        line: 197
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 3,
            column: 23
          },
          end: {
            line: 3,
            column: 102
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 3,
            column: 23
          },
          end: {
            line: 3,
            column: 48
          }
        }, {
          start: {
            line: 3,
            column: 52
          },
          end: {
            line: 3,
            column: 102
          }
        }],
        line: 3
      },
      '1': {
        loc: {
          start: {
            line: 5,
            column: 36
          },
          end: {
            line: 5,
            column: 81
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 5,
            column: 36
          },
          end: {
            line: 5,
            column: 73
          }
        }, {
          start: {
            line: 5,
            column: 77
          },
          end: {
            line: 5,
            column: 81
          }
        }],
        line: 5
      },
      '2': {
        loc: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 32,
            column: 5
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 11,
            column: 45
          },
          end: {
            line: 20,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 32,
            column: 5
          }
        }],
        line: 11
      },
      '3': {
        loc: {
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 111
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 38
          }
        }, {
          start: {
            line: 35,
            column: 42
          },
          end: {
            line: 35,
            column: 111
          }
        }],
        line: 35
      },
      '4': {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }],
        line: 38
      },
      '5': {
        loc: {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 23
          }
        }, {
          start: {
            line: 38,
            column: 27
          },
          end: {
            line: 38,
            column: 41
          }
        }],
        line: 38
      },
      '6': {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        }, {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 52,
            column: 7
          }
        }],
        line: 50
      },
      '7': {
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 49
          }
        }, {
          start: {
            line: 55,
            column: 53
          },
          end: {
            line: 55,
            column: 83
          }
        }],
        line: 55
      },
      '8': {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }],
        line: 57
      },
      '9': {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }],
        line: 62
      },
      '10': {
        loc: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 51
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 28
          }
        }, {
          start: {
            line: 62,
            column: 32
          },
          end: {
            line: 62,
            column: 51
          }
        }],
        line: 62
      },
      '11': {
        loc: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        }, {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        }],
        line: 81
      },
      '12': {
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }, {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }],
        line: 86
      },
      '13': {
        loc: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 124,
            column: 175
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 124,
            column: 43
          },
          end: {
            line: 124,
            column: 170
          }
        }, {
          start: {
            line: 124,
            column: 173
          },
          end: {
            line: 124,
            column: 175
          }
        }],
        line: 124
      },
      '14': {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 175
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 126,
            column: 40
          },
          end: {
            line: 126,
            column: 170
          }
        }, {
          start: {
            line: 126,
            column: 173
          },
          end: {
            line: 126,
            column: 175
          }
        }],
        line: 126
      },
      '15': {
        loc: {
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 128,
            column: 185
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 128,
            column: 43
          },
          end: {
            line: 128,
            column: 180
          }
        }, {
          start: {
            line: 128,
            column: 183
          },
          end: {
            line: 128,
            column: 185
          }
        }],
        line: 128
      },
      '16': {
        loc: {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }, {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }],
        line: 130
      },
      '17': {
        loc: {
          start: {
            line: 133,
            column: 15
          },
          end: {
            line: 133,
            column: 113
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 133,
            column: 15
          },
          end: {
            line: 133,
            column: 40
          }
        }, {
          start: {
            line: 133,
            column: 44
          },
          end: {
            line: 133,
            column: 113
          }
        }],
        line: 133
      },
      '18': {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }],
        line: 137
      },
      '19': {
        loc: {
          start: {
            line: 137,
            column: 10
          },
          end: {
            line: 137,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 137,
            column: 10
          },
          end: {
            line: 137,
            column: 23
          }
        }, {
          start: {
            line: 137,
            column: 27
          },
          end: {
            line: 137,
            column: 41
          }
        }],
        line: 137
      },
      '20': {
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        }, {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        }],
        line: 150
      },
      '21': {
        loc: {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        }, {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        }],
        line: 154
      },
      '22': {
        loc: {
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 162,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 162,
            column: 7
          }
        }, {
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 162,
            column: 7
          }
        }],
        line: 159
      },
      '23': {
        loc: {
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }, {
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }],
        line: 168
      },
      '24': {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        }, {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        }],
        line: 173
      },
      '25': {
        loc: {
          start: {
            line: 192,
            column: 46
          },
          end: {
            line: 192,
            column: 94
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 192,
            column: 46
          },
          end: {
            line: 192,
            column: 86
          }
        }, {
          start: {
            line: 192,
            column: 90
          },
          end: {
            line: 192,
            column: 94
          }
        }],
        line: 192
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_y61i3kwkv.s[0]++;

angular.module('app').controller('MenuCtrl', function ($rootScope, $scope, $state) {
  cov_y61i3kwkv.f[0]++;
  cov_y61i3kwkv.s[1]++;

  $scope.isPortfolio = (cov_y61i3kwkv.b[0][0]++, $rootScope.currentProject) && (cov_y61i3kwkv.b[0][1]++, $rootScope.currentProject.project.PORTFOLIO == '1');

  var settings = (cov_y61i3kwkv.s[2]++, angular.fromJson((cov_y61i3kwkv.b[1][0]++, localStorage.getItem('MENU-SETTINGS')) || (cov_y61i3kwkv.b[1][1]++, '[]')));

  cov_y61i3kwkv.s[3]++;
  $scope.settings = {
    saveChange: function saveChange() {
      cov_y61i3kwkv.s[4]++;

      localStorage.setItem('MENU-SETTINGS', angular.toJson(this.availableItems.map(function (item) {
        cov_y61i3kwkv.f[1]++;
        cov_y61i3kwkv.s[5]++;
        return item.name;
      })));
    },

    items: ($rootScope.connectedUser.multi ? (cov_y61i3kwkv.b[2][0]++, [{ name: 'MENU_SHORT.AC', id: '1_3', key: 'ACTOR', portfolio: false, link: 'settings.Actors', vuePorfolio: true }, { name: 'MENU_SHORT.FINANCING', id: '1_12', key: 'FINANCING', portfolio: false, link: 'settings.financing', vuePorfolio: true }, { name: 'MENU.C_B', id: '1_11', key: 'CAT_BUDGET', portfolio: false, link: 'settings.categories', vuePorfolio: true }, { name: 'MENU_SHORT.UN', id: '1_2', key: 'UNIT', portfolio: false, link: 'settings.Unit', vuePorfolio: true }, { name: 'MENU_SHORT.C_I', id: '3_6', key: 'CAT_INDICATOR', portfolio: false, link: 'settings.CatIndic', vuePorfolio: true }, { name: 'MENU.FL', id: '1_6', key: 'FLAG', portfolio: false, link: 'settings.flag', vuePorfolio: true }, { name: 'MENU.ALERT', id: '1_7', key: 'ALERT', portfolio: false, isAlert: true, vuePorfolio: $scope.isPortfolio }, { name: 'HEADER.TITLE', id: '1_15', key: '', portfolio: true, isHeader: true, vuePorfolio: $scope.isPortfolio }]) : (cov_y61i3kwkv.b[2][1]++, [{ name: 'MENU_SHORT.AGENCIES', id: '1_14', key: '', portfolio: true, link: 'settings.agencies', vuePorfolio: true }, { name: 'MENU_SHORT.AC', id: '1_3', key: 'ACTOR', portfolio: false, link: 'settings.Actors', vuePorfolio: true }, { name: 'MENU_SHORT.S_F', id: '1_8', key: 'FINANCING_SOURCE', portfolio: true, link: 'settings.Sfin', vuePorfolio: true }, { name: 'MENU_SHORT.FINANCING', id: '1_12', key: 'FINANCING', portfolio: false, link: 'settings.financing', vuePorfolio: true }, { name: 'MENU.C_B', id: '1_11', key: 'CAT_BUDGET', portfolio: false, link: 'settings.categories', vuePorfolio: true }, { name: 'MENU_SHORT.UN', id: '1_2', key: 'UNIT', portfolio: false, link: 'settings.Unit', vuePorfolio: true }, { name: 'MENU_SHORT.C_I', id: '3_6', key: 'CAT_INDICATOR', portfolio: false, link: 'settings.CatIndic', vuePorfolio: true }, { name: 'MENU.FL', id: '1_6', key: 'FLAG', portfolio: false, link: 'settings.flag', vuePorfolio: true }, { name: 'MENU.ALERT', id: '1_7', key: 'ALERT', portfolio: false, isAlert: true, vuePorfolio: $scope.isPortfolio }, { name: 'HEADER.TITLE', id: '1_15', key: '', portfolio: true, isHeader: true, vuePorfolio: $scope.isPortfolio }, { name: 'MENU_SHORT.LAYERS', id: '1_16', key: '', portfolio: true, link: 'settings.layers', vuePorfolio: true }])).filter(function (item) {
      cov_y61i3kwkv.f[2]++;
      cov_y61i3kwkv.s[6]++;

      return (cov_y61i3kwkv.b[3][0]++, $rootScope.currentProject) && (cov_y61i3kwkv.b[3][1]++, !$rootScope.currentProject.droit.RIGHT_STR.includes(';' + item.id + ':0;'));
    }),
    addItem: function addItem(item) {
      cov_y61i3kwkv.s[7]++;

      if ((cov_y61i3kwkv.b[5][0]++, !item.isAlert) && (cov_y61i3kwkv.b[5][1]++, !item.isHeader)) {
        cov_y61i3kwkv.b[4][0]++;
        cov_y61i3kwkv.s[8]++;

        item.display = true;
        cov_y61i3kwkv.s[9]++;

        this.availableItems.push(item);
      } else {
        cov_y61i3kwkv.b[4][1]++;
      }
      cov_y61i3kwkv.s[10]++;
      this.saveChange();

      cov_y61i3kwkv.s[11]++;
      this.loadItem(item);
    },
    removeItem: function removeItem(item) {
      cov_y61i3kwkv.s[12]++;

      item.display = false;
      var index = (cov_y61i3kwkv.s[13]++, this.availableItems.indexOf(item));
      cov_y61i3kwkv.s[14]++;
      if (index >= 0) {
        cov_y61i3kwkv.b[6][0]++;
        cov_y61i3kwkv.s[15]++;

        this.availableItems.splice(index, 1);
      } else {
        cov_y61i3kwkv.b[6][1]++;
      }
      cov_y61i3kwkv.s[16]++;
      this.saveChange();

      var nextItem = (cov_y61i3kwkv.s[17]++, (cov_y61i3kwkv.b[7][0]++, this.availableItems[index]) || (cov_y61i3kwkv.b[7][1]++, this.availableItems[index - 1]));

      cov_y61i3kwkv.s[18]++;
      if (!nextItem) {
        cov_y61i3kwkv.b[8][0]++;
        cov_y61i3kwkv.s[19]++;

        $state.go('settings.logical_plan');
        cov_y61i3kwkv.s[20]++;
        return;
      } else {
        cov_y61i3kwkv.b[8][1]++;
      }

      cov_y61i3kwkv.s[21]++;
      if ((cov_y61i3kwkv.b[10][0]++, nextItem.portfolio) && (cov_y61i3kwkv.b[10][1]++, !$scope.isPortfolio)) {
        cov_y61i3kwkv.b[9][0]++;
        cov_y61i3kwkv.s[22]++;

        this.removeItem(nextItem);
        cov_y61i3kwkv.s[23]++;
        return;
      } else {
        cov_y61i3kwkv.b[9][1]++;
      }

      cov_y61i3kwkv.s[24]++;
      this.loadItem(nextItem);
    },

    availableItems: [],
    loadItem: function loadItem(item) {
      cov_y61i3kwkv.s[25]++;

      if (item.isHeader) {
        cov_y61i3kwkv.b[11][0]++;
        cov_y61i3kwkv.s[26]++;

        $scope.openHeader();
        cov_y61i3kwkv.s[27]++;
        return;
      } else {
        cov_y61i3kwkv.b[11][1]++;
      }

      cov_y61i3kwkv.s[28]++;
      if (item.isAlert) {
        cov_y61i3kwkv.b[12][0]++;
        cov_y61i3kwkv.s[29]++;

        $scope.alert.open();
        cov_y61i3kwkv.s[30]++;
        return;
      } else {
        cov_y61i3kwkv.b[12][1]++;
      }

      cov_y61i3kwkv.s[31]++;
      for (var _iterator = this.items, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var item_ = _ref;
        cov_y61i3kwkv.s[32]++;

        item_.active = false;
      }
      cov_y61i3kwkv.s[33]++;
      item.active = true;
      cov_y61i3kwkv.s[34]++;
      $scope.divScrollRight('.theme_blue .pretty-scroll');
      cov_y61i3kwkv.s[35]++;
      $state.go(item.link);
    },
    closeItem: function closeItem() {
      cov_y61i3kwkv.s[36]++;

      for (var _iterator2 = this.items, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var item_ = _ref2;
        cov_y61i3kwkv.s[37]++;

        item_.active = false;
      }
    }
  };

  cov_y61i3kwkv.s[38]++;
  $scope.settings.availableItems = $scope.settings.items.filter(function (item) {
    cov_y61i3kwkv.f[3]++;
    cov_y61i3kwkv.s[39]++;

    return settings.indexOf(item.name) >= 0;
  });
  cov_y61i3kwkv.s[40]++;
  $scope.settings.items.map(function (item) {
    cov_y61i3kwkv.f[4]++;
    cov_y61i3kwkv.s[41]++;

    item.display = settings.indexOf(item.name) >= 0;
    cov_y61i3kwkv.s[42]++;
    return item;
  });

  cov_y61i3kwkv.s[43]++;
  $scope.activityPlanBudget = {
    saveChange: function saveChange() {
      cov_y61i3kwkv.s[44]++;

      localStorage.setItem('MENU-PLAN-BUDGET', angular.toJson(this.availableItems.map(function (item) {
        cov_y61i3kwkv.f[5]++;
        cov_y61i3kwkv.s[45]++;
        return item.name;
      })));
    },

    items: [{ name: 'MENU_SHORT.FUNDS', id: '2_5', key: 'DISBURSEMENT', portfolio: false, link: 'project_mgt.funds_disbursement' }, { name: 'MENU_SHORT.PROJECT_TIMELINE', id: '2_4', key: 'GANTT_CHART', portfolio: false, link: 'project_mgt.project_timeline' }, { name: 'MENU_SHORT.ACTIVITY_REPORT', id: '2_7', key: 'ACTIVITY_REPORT', portfolio: false, link: 'project_mgt.report' }, { name: 'MENU_SHORT.T_RA', id: '', portfolio: false, link: 'project_mgt.staffreports.planning' }].concat($scope.complementModules.mission ? (cov_y61i3kwkv.b[13][0]++, [{ name: 'MENU_SHORT.MISSION_MANAGEMENT', id: '2_6', key: 'MISSION_MANAGEMENT', portfolio: false, link: 'project_mgt.missions' }]) : (cov_y61i3kwkv.b[13][1]++, [])).concat($scope.complementModules.risk ? (cov_y61i3kwkv.b[14][0]++, [{ name: 'MENU_SHORT.RISKS_MANAGEMENT', id: '2_3', key: 'RISK_MANAGEMENT', portfolio: false, link: 'project_mgt.risks_management' }]) : (cov_y61i3kwkv.b[14][1]++, [])).concat($scope.complementModules.problem ? (cov_y61i3kwkv.b[15][0]++, [{ name: 'MENU_SHORT.PROBLEM_MANAGEMENT', id: '2_8', key: 'PROBLEM_MANAGEMENT', portfolio: false, link: 'project_mgt.problem_management' }]) : (cov_y61i3kwkv.b[15][1]++, [])).filter(function (item) {
      cov_y61i3kwkv.f[6]++;
      cov_y61i3kwkv.s[46]++;

      if (item.id === '') {
        cov_y61i3kwkv.b[16][0]++;
        cov_y61i3kwkv.s[47]++;

        return true;
      } else {
        cov_y61i3kwkv.b[16][1]++;
      }
      cov_y61i3kwkv.s[48]++;
      return (cov_y61i3kwkv.b[17][0]++, $rootScope.currentProject) && (cov_y61i3kwkv.b[17][1]++, !$rootScope.currentProject.droit.RIGHT_STR.includes(';' + item.id + ':0;'));
    }),

    addItem: function addItem(item) {
      cov_y61i3kwkv.s[49]++;

      if ((cov_y61i3kwkv.b[19][0]++, !item.isAlert) && (cov_y61i3kwkv.b[19][1]++, !item.isHeader)) {
        cov_y61i3kwkv.b[18][0]++;
        cov_y61i3kwkv.s[50]++;

        item.display = true;
        cov_y61i3kwkv.s[51]++;

        this.availableItems.push(item);
      } else {
        cov_y61i3kwkv.b[18][1]++;
      }

      cov_y61i3kwkv.s[52]++;
      this.saveChange();
      cov_y61i3kwkv.s[53]++;
      this.loadItem(item);
      cov_y61i3kwkv.s[54]++;
      $scope.divScrollRight('.theme_blue .pretty-scroll');
    },
    removeItem: function removeItem(item) {
      cov_y61i3kwkv.s[55]++;

      item.display = false;
      var index = (cov_y61i3kwkv.s[56]++, this.availableItems.indexOf(item));
      cov_y61i3kwkv.s[57]++;
      if (index >= 0) {
        cov_y61i3kwkv.b[20][0]++;
        cov_y61i3kwkv.s[58]++;

        this.availableItems.splice(index, 1);
      } else {
        cov_y61i3kwkv.b[20][1]++;
      }
      cov_y61i3kwkv.s[59]++;
      this.saveChange();
      cov_y61i3kwkv.s[60]++;
      if (angular.isDefined(this.availableItems[index])) {
        cov_y61i3kwkv.b[21][0]++;
        cov_y61i3kwkv.s[61]++;

        this.loadItem(this.availableItems[index]);
        cov_y61i3kwkv.s[62]++;
        return;
      } else {
        cov_y61i3kwkv.b[21][1]++;
      }

      cov_y61i3kwkv.s[63]++;
      if (this.availableItems.length > 0) {
        cov_y61i3kwkv.b[22][0]++;
        cov_y61i3kwkv.s[64]++;

        this.loadItem(this.availableItems[index - 1]);
        cov_y61i3kwkv.s[65]++;
        return;
      } else {
        cov_y61i3kwkv.b[22][1]++;
      }

      cov_y61i3kwkv.s[66]++;
      $state.go('project_mgt.activity_plan_budget');
    },

    availableItems: [],
    loadItem: function loadItem(item) {
      cov_y61i3kwkv.s[67]++;

      if (item.isHeader) {
        cov_y61i3kwkv.b[23][0]++;
        cov_y61i3kwkv.s[68]++;

        $scope.openHeader();
        cov_y61i3kwkv.s[69]++;
        return;
      } else {
        cov_y61i3kwkv.b[23][1]++;
      }

      cov_y61i3kwkv.s[70]++;
      if (item.isAlert) {
        cov_y61i3kwkv.b[24][0]++;
        cov_y61i3kwkv.s[71]++;

        $scope.alert.open();
        cov_y61i3kwkv.s[72]++;
        return;
      } else {
        cov_y61i3kwkv.b[24][1]++;
      }

      cov_y61i3kwkv.s[73]++;
      for (var _iterator3 = this.items, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var item_ = _ref3;
        cov_y61i3kwkv.s[74]++;

        item_.active = false;
      }
      cov_y61i3kwkv.s[75]++;
      item.active = true;
      cov_y61i3kwkv.s[76]++;
      $scope.divScrollRight('.theme_blue .pretty-scroll');
      cov_y61i3kwkv.s[77]++;
      $state.go(item.link);
    },
    closeItem: function closeItem() {
      cov_y61i3kwkv.s[78]++;

      for (var _iterator4 = this.items, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var item_ = _ref4;
        cov_y61i3kwkv.s[79]++;

        item_.active = false;
      }
    }
  };

  var activityPlanBudget = (cov_y61i3kwkv.s[80]++, angular.fromJson((cov_y61i3kwkv.b[25][0]++, localStorage.getItem('MENU-PLAN-BUDGET')) || (cov_y61i3kwkv.b[25][1]++, '[]')));
  cov_y61i3kwkv.s[81]++;
  $scope.activityPlanBudget.availableItems = $scope.activityPlanBudget.items.filter(function (item) {
    cov_y61i3kwkv.f[7]++;
    cov_y61i3kwkv.s[82]++;

    return activityPlanBudget.indexOf(item.name) >= 0;
  });

  cov_y61i3kwkv.s[83]++;
  $scope.activityPlanBudget.items.map(function (item) {
    cov_y61i3kwkv.f[8]++;
    cov_y61i3kwkv.s[84]++;

    item.display = activityPlanBudget.indexOf(item.name) >= 0;
    cov_y61i3kwkv.s[85]++;
    return item;
  });
});